import {Hub} from 'yougile-model'
import {COLUMN_NAMES} from '../../constants'
import {Row, State} from '../../types'
import {addToCheckProcessedColumn} from '../utils/add-to-check-processed-column'

export const processDescription = (state: State, row: Row, task: Hub): void => {
  const keys = (Object.keys(row) as (keyof Row)[])
    .filter(Boolean)
    .filter(key => key.toLocaleLowerCase().startsWith(COLUMN_NAMES.DESCRIPTION))

  const values = keys.map(key => row[key])

  keys.forEach(key => {
    addToCheckProcessedColumn(state, key)
  })

  task.description = values.join('<br/><br/>')
}
